import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import './Policy.css';

const ShippingDelivery = () => {
  return (
    <div className="App">
      <Header />
      <div className="page policy-page">
        <div className="container">
          <div className="policy-header">
            <h1>Shipping/Delivery Policy</h1>
            <p className="policy-updated">Last Updated: January 2025</p>
          </div>

          <div className="policy-content">
            <section className="policy-section">
              <h2>1. Delivery Options</h2>
              <div className="policy-text">
                <h3>1.1 School Delivery (Pickup)</h3>
                <ul>
                  <li>Free delivery option</li>
                  <li>Orders will be delivered to your registered school</li>
                  <li>You can collect your order from the school office</li>
                  <li>Delivery timeline: 7-14 business days from order confirmation</li>
                  <li>You will be notified when your order is ready for pickup</li>
                </ul>

                <h3>1.2 Home Delivery</h3>
                <ul>
                  <li>Convenient delivery to your registered address</li>
                  <li>Delivery charges apply as per the number of kits ordered</li>
                  <li>1 kit: ₹150 delivery charge</li>
                  <li>2 or more kits: ₹300 delivery charge</li>
                  <li>Delivery timeline: 7-14 business days from order confirmation</li>
                  <li>Delivery will be made during business hours (9:00 AM - 6:00 PM)</li>
                </ul>
              </div>
            </section>

            <section className="policy-section">
              <h2>2. Delivery Timeline</h2>
              <div className="policy-text">
                <h3>2.1 Processing Time</h3>
                <ul>
                  <li>Order processing: 1-2 business days after payment confirmation</li>
                  <li>Packaging and dispatch: 1-2 business days</li>
                  <li>Transit time: 5-10 business days depending on location</li>
                  <li>Total delivery time: 7-14 business days from order confirmation</li>
                </ul>

                <h3>2.2 Delivery Delays</h3>
                <p>
                  While we strive to deliver within the estimated timeframe, delays may occur due to:
                </p>
                <ul>
                  <li>Unforeseen circumstances (natural disasters, pandemics, etc.)</li>
                  <li>Incorrect or incomplete address provided</li>
                  <li>Unavailability of recipient at delivery address</li>
                  <li>Logistics partner delays</li>
                </ul>
                <p>
                  In case of delays, we will notify you via email or phone and provide updated delivery estimates.
                </p>
              </div>
            </section>

            <section className="policy-section">
              <h2>3. Delivery Address</h2>
              <div className="policy-text">
                <h3>3.1 Address Requirements</h3>
                <ul>
                  <li>Please provide complete and accurate delivery address</li>
                  <li>Include street address, area, city, state, and PIN code</li>
                  <li>For home delivery, ensure someone is available to receive the order</li>
                  <li>Update your address in your account profile if it changes</li>
                </ul>

                <h3>3.2 Address Changes</h3>
                <p>
                  Address changes can be made before order confirmation. After confirmation, 
                  address changes may incur additional charges or delays. Contact our support team 
                  immediately if you need to change the delivery address.
                </p>
              </div>
            </section>

            <section className="policy-section">
              <h2>4. Delivery Process</h2>
              <div className="policy-text">
                <h3>4.1 Order Tracking</h3>
                <ul>
                  <li>You will receive order confirmation email with order number</li>
                  <li>Tracking information will be shared once order is dispatched</li>
                  <li>You can track your order status in your account dashboard</li>
                  <li>SMS/Email notifications will be sent at key stages</li>
                </ul>

                <h3>4.2 Delivery Attempts</h3>
                <ul>
                  <li>We will make up to 2 delivery attempts</li>
                  <li>If delivery fails, you will be contacted to reschedule</li>
                  <li>After 2 failed attempts, order may be returned to our warehouse</li>
                  <li>Additional delivery charges may apply for rescheduled deliveries</li>
                </ul>

                <h3>4.3 Delivery Confirmation</h3>
                <p>
                  Upon successful delivery, you will receive a delivery confirmation. Please verify 
                  the items received match your order. Report any discrepancies within 24 hours of delivery.
                </p>
              </div>
            </section>

            <section className="policy-section">
              <h2>5. Delivery Areas</h2>
              <div className="policy-text">
                <h3>5.1 Service Areas</h3>
                <p>
                  We currently deliver to major cities and towns across India. Delivery charges and 
                  timelines may vary based on your location. Please check delivery availability during checkout.
                </p>

                <h3>5.2 Remote Areas</h3>
                <p>
                  For remote or hard-to-reach areas, additional delivery charges may apply. 
                  Delivery timelines may also be extended. We will inform you of any additional 
                  charges before order confirmation.
                </p>
              </div>
            </section>

            <section className="policy-section">
              <h2>6. Damaged or Lost Shipments</h2>
              <div className="policy-text">
                <h3>6.1 Damaged Products</h3>
                <p>
                  If you receive damaged products, please:
                </p>
                <ol>
                  <li>Do not accept the damaged package if possible</li>
                  <li>Take photos of the damaged package and products</li>
                  <li>Contact our support team within 24 hours</li>
                  <li>We will arrange for replacement or refund</li>
                </ol>

                <h3>6.2 Lost Shipments</h3>
                <p>
                  If your order is lost in transit, we will investigate and either reship the order 
                  or provide a full refund. Please allow 7-10 business days for investigation.
                </p>
              </div>
            </section>

            <section className="policy-section">
              <h2>7. Contact for Delivery Queries</h2>
              <div className="policy-text">
                <p>
                  For any delivery-related queries, please contact us:
                </p>
                <ul>
                  <li><strong>Email:</strong> <a href="mailto:support@slnbooks.com">support@slnbooks.com</a></li>
                  <li><strong>Phone:</strong> <a href="tel:+919916832476">+91-9916832476</a>, <a href="tel:+919663622125">+91-9663622125</a></li>
                  <li><strong>Business Hours:</strong> Monday - Friday: 9:00 AM - 6:00 PM, Saturday: 10:00 AM - 4:00 PM</li>
                </ul>
              </div>
            </section>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default ShippingDelivery;

